<template>
    <div style="height: calc(100vh - 53px);">
        <div :style="{backgroundColor: themes[currentTheme].colors.bg}"
            style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
            <div class="spritz" v-if="ready">
                <div class="spritz-word" :style="{
            fontSize: fontSize + 'rem',
      lineHeight: lineHeight + 'rem',
      height: height + 'rem',
      color: themes[currentTheme].colors.text
          }">
                    <div style="opacity: .7">{{w1}}</div>
                    <div :style="{color: themes[currentTheme].colors.letter}">{{w2}}</div>
                    <div style="opacity: .7">{{w3}}</div>
                </div>
            </div>
            <div v-else style="width: 500px; background: whitesmoke; padding: 20px 30px;">
                <label for="" class="mb-2">Okumak istediğiniz metni aşağıya yapıştırınız.</label>
                <textarea name="" id="" cols="30" rows="10" class="form-control" v-model="metin"></textarea>
                <el-button type="primary" round @click="start" class="mt-2">BAŞLA</el-button>
            </div>
            <div
                style="bottom: 0px; left: 0px;  position: absolute; display: flex; align-items: center; justify-content: space-between; flex-direction: row; width: 100%; box-sizing: border-box; padding: 10px">
                <span>
                    <el-button size="mini" @click="drawer = true">Ayarlar</el-button>
                    [{{(60000/interval).toFixed(0)}} kelime/dakika]
                </span>
                <el-button size="mini" @click="stop">Metni Değiştir</el-button>
                <img src="https://old.360hizliokuma.com.tr/assets/img/logo.svg" style="height: 30px;">
            </div>

            <el-drawer :size="210" :visible.sync="drawer" direction="btt" :append-to-body="true">
                <div
                    style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0px 30px">
                    <div style="width: 40%;">
                        <label for="">Hız</label>
                        <el-slider :step="50" :min="100" :max="1000" v-model="interval" />
                    </div>
                    <div style="width: 40%;">
                        <label for="">Boyut</label>
                        <el-slider :step="0.1" :min="0.2" :max="1.7" v-model="zoom" />
                    </div>
                    <div style="width: 10%;">
                        <label for="" style="display: block">Ses</label>
                        <el-switch :active-value="'true'" :inactive-value="'false'" v-model="sound"></el-switch>
                    </div>
                </div>
                <div style="width: 100%; display: flex; align-items: center; justify-content: center; margin-top: 20px;">
                    <div @click="currentTheme = index" v-for="(theme, index) in themes"
                        :style="{backgroundColor: theme.colors.bg, color: theme.colors.text, border: index == currentTheme ? '1px solid #fff' : ''}"
                        style="height: 60px; width: 120px; text-align: center; margin-right: 10px; box-sizing: border-box; line-height: 60px; cursor: pointer;">
                        {{ theme.title }}
                    </div>
                </div>
            </el-drawer>
        </div>

    </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";

export default {
    name: "GozeRitim",
    props: ["config"],
    data() {
        return {
            words: `360 Hızlı Okuma`
                .replace(/\s{2,}/g, " ")
                .split(" "),
            i: 0,
            w1: '',
            w2: '',
            w3: '',
            zoom: 1,
            drawer: false,
            ready: false,
            currentTheme: 0,
            themes: [{
                title: "Tema 1",
                colors: {
                    bg: "#c6d2e9",
                    text: "#30183c",
                    letter: "#4a2c5e"
                }
            },
            {
                title: "Tema 2",
                colors: {
                    bg: "#c3a884",
                    text: "#3f5a7e",
                    letter: "#384f6f"
                }
            },
            {
                title: "Tema 3",
                colors: {
                    bg: "#8d40d0",
                    text: "#002400",
                    letter: "#003800"
                }
            },

            {
                title: "Tema 4",
                colors: {
                    bg: "#4a7767",
                    text: "#3e1928",
                    letter: "#502034"
                }
            },
            {
                title: "Tema 5",
                colors: {
                    bg: "#141625",
                    text: "#e8e6d7",
                    letter: "#fcfbf9"
                }
            },
            {
                title: "Tema 6",
                colors: {
                    bg: "#c7a6c7",
                    text: "#3b5c3b",
                    letter: "#456c45"
                }
            }
            ],
            spritz: null,
            interval: 400,
            sound: "true",
            audio: new Audio('/static/tick.mp3'),
            metin: '',
            metinler: []
        };
    },
    methods: {
        stop() {
            this.ready = false;
            clearInterval(this.spritz);
        },
        start() {
            if (this.metin == '') {
                return this.$message.error("Lütfen metin girin");
            }
            this.words = this.metin.replace(/\s{2,}/g, " ")
                .split(" ");
            this.ready = true;
            clearInterval(this.spritz);
            this.word_show(0);
            this.word_update(this.interval);
        },
        word_show() {
            var word = this.words[this.i];
            var stop = Math.round((word.length + 1) * 0.4) - 1;
            this.w1 = word.slice(0, stop);
            this.w2 = word[stop];
            this.w3 = word.slice(stop + 1);

        },
        word_update(interval) {
            this.spritz = setInterval(() => {
                if (this.drawer) {
                    return;
                }
                if (this.sound == "true") {
                    this.audio.pause();
                    this.audio.currentTime = 0;
                    this.audio.play();
                }

                this.word_show(this.i);
                this.i++;
                if (this.i == this.words.length) {
                    setTimeout(() => {
                        this.word_show();
                        this.word_update(interval);
                    }, interval);
                    clearInterval(this.spritz);
                    this.i = 0;



                }
            }, interval);
        },
    },
    created() {




        if (localStorage.getItem("o_zoom")) {
            this.zoom = localStorage.getItem("o_zoom");
        }

        if (localStorage.getItem("o_theme")) {
            this.currentTheme = localStorage.getItem("o_theme");
        }

        if (localStorage.getItem("o_interval")) {
            this.interval = localStorage.getItem("o_interval");
        }

        if (localStorage.getItem("o_sound")) {
            this.sound = localStorage.getItem("o_sound");
        }


    },
    computed: {
        lineHeight() {
            return 7.2 * this.zoom;
        },
        height() {
            return 7.2 * this.zoom;
        },
        fontSize() {
            return 6.4 * this.zoom;
        },
    },
    watch: {
        zoom: function () {
            localStorage.setItem("o_zoom", this.zoom)
        },
        currentTheme: function () {


            localStorage.setItem("o_theme", this.currentTheme)
        },
        sound: function () {

            localStorage.setItem("o_sound", this.sound)
        },
        interval: function () {

            localStorage.setItem("o_interval", this.interval)


            clearInterval(this.spritz);
            this.word_show(0);
            this.word_update(this.interval);


        }
    },
    beforeDestroy() {
        clearInterval(this.spritz);
    }
};
</script>

<style lang="less" scoped>
.spritz {

    position: relative;
    width: 100%;
    padding: 1rem 0 1.2rem;
    border-top: 2px solid #ddd;
    border-bottom: 2px solid #ddd;
    margin: 10rem auto;
}

.spritz:before,
.spritz:after {
    content: "";
    position: absolute;
    left: 49%;
    height: 0.8rem;
    width: 2px;
    margin-left: -1px;
    background-color: #ddd;
}

.spritz:before {
    top: 0;
}

.spritz:after {
    bottom: 0;
}

.spritz-word {
    font-size: 6.4rem;
    line-height: 7.2rem;
    height: 7.2rem;
    font-weight: 600;
}

.spritz-word div {

    display: table-cell;
}

.spritz-word div:first-child {
    width: 49%;
    text-align: right;
}

.spritz-word div:last-child {
    width: 60%;
    text-align: left;
}


#goz_esnetme {
    width: 700px;
    min-height: 550px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    position: relative;
    padding: 20px;
    margin-top: 20px;
    display: block;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
}

.is-dark {
    #goz_esnetme {
        background: black;
    }
}
</style>

<style>
.el-drawer__header {
    margin-bottom: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/OdakOkuma.vue